module.exports = __webpack_public_path__ + "img/coupon.bf0b9db6.png";